/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamLangsExamlangidItemsQueryResponse,
  GetApiV1ExamLangsExamlangidItemsPathParams,
  GetApiV1ExamLangsExamlangidItemsQueryParams,
  GetApiV1ExamLangsExamlangidItems401,
  GetApiV1ExamLangsExamlangidItems404,
  GetApiV1ExamLangsExamlangidItems500,
} from "../../types/examEvaluationController/GetApiV1ExamLangsExamlangidItems.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamLangsExamlangidItems } from "../../clients/examEvaluationController/getApiV1ExamLangsExamlangidItems.ts";

export const getApiV1ExamLangsExamlangidItemsQueryKey = (
  examLangId: GetApiV1ExamLangsExamlangidItemsPathParams["examLangId"],
  params?: GetApiV1ExamLangsExamlangidItemsQueryParams,
) =>
  [
    {
      url: "/api/v1/exam/langs/:examLangId/items",
      params: { examLangId: examLangId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ExamLangsExamlangidItemsQueryKey = ReturnType<
  typeof getApiV1ExamLangsExamlangidItemsQueryKey
>;

export function getApiV1ExamLangsExamlangidItemsQueryOptions(
  examLangId: GetApiV1ExamLangsExamlangidItemsPathParams["examLangId"],
  params?: GetApiV1ExamLangsExamlangidItemsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamLangsExamlangidItemsQueryKey(examLangId, params);
  return queryOptions<
    GetApiV1ExamLangsExamlangidItemsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamLangsExamlangidItems401
      | GetApiV1ExamLangsExamlangidItems404
      | GetApiV1ExamLangsExamlangidItems500
    >,
    GetApiV1ExamLangsExamlangidItemsQueryResponse,
    typeof queryKey
  >({
    enabled: !!examLangId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamLangsExamlangidItems(examLangId, params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a lista paginada de questões associadas ao idioma de prova informado. **(Requer Authorization para autenticação)**
 * @summary Listar questões de um idioma de prova (Requer Authorization para autenticação)
 * {@link /api/v1/exam/langs/:examLangId/items}
 */
export function useGetApiV1ExamLangsExamlangidItems<
  TData = GetApiV1ExamLangsExamlangidItemsQueryResponse,
  TQueryData = GetApiV1ExamLangsExamlangidItemsQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamLangsExamlangidItemsQueryKey,
>(
  examLangId: GetApiV1ExamLangsExamlangidItemsPathParams["examLangId"],
  params?: GetApiV1ExamLangsExamlangidItemsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamLangsExamlangidItemsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamLangsExamlangidItems401
          | GetApiV1ExamLangsExamlangidItems404
          | GetApiV1ExamLangsExamlangidItems500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ExamLangsExamlangidItemsQueryKey(examLangId, params);

  const query = useQuery(
    {
      ...getApiV1ExamLangsExamlangidItemsQueryOptions(
        examLangId,
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamLangsExamlangidItems401
      | GetApiV1ExamLangsExamlangidItems404
      | GetApiV1ExamLangsExamlangidItems500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
